import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoader:false,
  allReviews:[],
}

export const ReviewSlice = createSlice({
  name: 'allReview',
  initialState,
  reducers: {
    getReviewStart: (state,action) => {
        state.isLoader= true
    },
    getReviewSuccess: (state,action) => {
        state.isLoader= false
        state.allReviews = action.payload
    },
    deleteReview: (state,action) => {
      state.isLoader = true
      state.allReviews = state.allReviews.filter((elem)=>elem._id !== action.payload)
      state.isLoader = false

    },
    updateReview: (state,action) => {
      const Index = state.allReviews.findIndex(review => review._id === action.payload._id);
      if(Index !== -1 ){
        state.allReviews[Index] = action.payload;
      }
    }
  },
})

export const {getReviewStart, getReviewSuccess, deleteReview, updateReview} = ReviewSlice.actions

export default ReviewSlice.reducer